export const PAGES_KEY = 'pages';
export const UNRESOLVED_INDEX = -1;
